"use client"

import { useEffect, useState } from "react"
import { useParams } from "react-router"
import YouTube from "react-youtube"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import YoutubeSlider from "../component/YoutubeSlider"
import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

const Video = () => {
    const { youtubeId, youtubeObjectId } = useParams()
    const youtubeList = useSelector((state) => state.youtube.youtubeData)
    const [youtubeObjectData, setYoutubeObjectData] = useState({})
    const [showFullDescription, setShowFullDescription] = useState(false)

    const navigate = useNavigate()

    const opts = {
        height: "500",
        width: "100%",
        playerVars: {
            autoplay: 0,
            rel: 0,
            modestbranding: 1,
        },
    }

    const selectedYoutubeData = {
        id: youtubeId,
        data: youtubeList[youtubeId]?.list.filter((obj) => obj.url === youtubeObjectId),
    }

    useEffect(() => {
        setYoutubeObjectData(selectedYoutubeData?.data)
    }, [youtubeId, youtubeObjectId])

    const handleBackClick = () => {
        navigate(-1)
    }

    const formatDate = (dateString) => {
        if (!dateString) return ""
        const date = new Date(dateString)
        return date.toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "long",
            day: "numeric",
        })
    }

    // 인라인 스타일로 CSS 문제 해결
    const pageStyle = {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
        color: "#f8fafc",
        padding: "2rem 0",
        marginLeft: "calc(-50vw + 50%) !important",
        width: "width: 100vw !important"

}

    const containerStyle = {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 2rem",
    }

    const backButtonStyle = {
        position: "fixed",
        top: "2rem",
        left: "2rem",
        zIndex: 1000,
        background: "rgba(0, 0, 0, 0.7)",
        border: "none",
        borderRadius: "50%",
        width: "48px",
        height: "48px",
        color: "white",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.2rem",
    }

    const videoContainerStyle = {
        background: "#000",
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "2rem",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
    }

    const titleStyle = {
        fontSize: "2rem",
        fontWeight: "700",
        marginBottom: "1rem",
        color: "#f1f5f9",
    }

    const metaStyle = {
        background: "rgba(255, 255, 255, 0.1)",
        borderRadius: "12px",
        padding: "1.5rem",
        marginBottom: "2rem",
        backdropFilter: "blur(10px)",
    }

    const channelInfoStyle = {
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginBottom: "1rem",
    }

    const avatarStyle = {
        width: "48px",
        height: "48px",
        background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontSize: "1.2rem",
    }

    const actionButtonsStyle = {
        display: "flex",
        gap: "1rem",
        flexWrap: "wrap",
    }

    const buttonStyle = {
        background: "rgba(255, 255, 255, 0.1)",
        border: "none",
        borderRadius: "25px",
        padding: "0.7rem 1.2rem",
        color: "#e2e8f0",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        transition: "all 0.3s ease",
    }

    const descriptionStyle = {
        background: "rgba(255, 255, 255, 0.05)",
        borderRadius: "12px",
        padding: "2rem",
        marginBottom: "2rem",
    }

    const VideoContent = () => (
        <div style={pageStyle}>


            <div style={containerStyle}>
                {/* 비디오 플레이어 */}
                <div style={videoContainerStyle}>
                    <YouTube videoId={youtubeObjectId} opts={opts} />
                </div>

                {/* 비디오 정보 */}
                <h1 style={titleStyle}>{youtubeObjectData[0]?.title || "설교 영상"}</h1>

                <div style={metaStyle}>
                    <div style={channelInfoStyle}>
                        <div style={avatarStyle}>⛪</div>
                        <div>
                            <div style={{ fontWeight: "600", marginBottom: "0.3rem" }}>의정부 성실교회</div>
                            <div style={{ fontSize: "0.9rem", color: "#94a3b8" }}>
                                📅 {formatDate(youtubeObjectData[0]?.updateTime)}
                            </div>
                        </div>
                    </div>

                </div>

                {/* 설명 */}
                {youtubeObjectData[0]?.subTitle && (
                    <div style={descriptionStyle}>
                        <h3 style={{ marginBottom: "1rem", color: "#e2e8f0" }}>📖 내용</h3>
                        <p
                            style={{
                                lineHeight: "1.7",
                                color: "#cbd5e1",
                                display: showFullDescription ? "block" : "-webkit-box",
                                WebkitLineClamp: showFullDescription ? "none" : "3",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                            }}
                        >
                            {youtubeObjectData[0]?.subTitle}
                        </p>
                        {youtubeObjectData[0]?.subTitle?.length > 150 && (
                            <button
                                style={{
                                    ...buttonStyle,
                                    marginTop: "1rem",
                                    background: "none",
                                    color: "#60a5fa",
                                }}
                                onClick={() => setShowFullDescription(!showFullDescription)}
                            >
                                {showFullDescription ? "간략히 보기 ▲" : "더보기 ▼"}
                            </button>
                        )}
                    </div>
                )}

                {/* 관련 영상 */}
                <div>
                    <h3
                        style={{
                            fontSize: "1.5rem",
                            marginBottom: "1.5rem",
                            color: "#e2e8f0",
                        }}
                    >
                        🎬 같은 카테고리의 다른 영상
                    </h3>
                    <YoutubeSlider youtubeListId={youtubeId} limit="6"/>
                </div>
            </div>
        </div>
    )

    return (
        <section className="pf-page" style={{padding : 0}}>
            <PC>
                <VideoContent />
            </PC>
            <Notebook>
                <VideoContent />
            </Notebook>
            <Tablet>
                <VideoContent />
            </Tablet>
            <Mobile>
                <VideoContent />
            </Mobile>
        </section>
    )
}

export default Video
